import { defineComponent as d, computed as c, createBlock as u, openBlock as n, unref as a, normalizeClass as m, withCtx as p, createElementVNode as s, createElementBlock as f, createCommentVNode as b, renderSlot as r, createVNode as h, createTextVNode as v, toDisplayString as B } from "vue";
import { RevButtonBase as _ } from "@ds/components/ButtonBase";
import x from "../../../icons/generated/IconChevronDown.vue2.js";
import { tw as t } from "../../../utils/tailwind.js";
const y = { class: "body-2-bold h-full text-start" }, g = { class: "pointer-events-none absolute inset-y-0 right-8 flex select-none items-center" }, w = {
  key: 0,
  class: "text-static-default-low caption pointer-events-none absolute inset-x-12 top-0 flex items-center pr-16"
}, V = /* @__PURE__ */ d({
  name: "InputSmallSelectButton",
  __name: "InputSmallSelectButton",
  props: {
    hasError: { type: Boolean },
    focused: { type: Boolean },
    disabled: { type: Boolean },
    required: { type: Boolean }
  },
  setup(l) {
    const e = l, i = c(() => [
      t`rounded-sm relative inline-block h-32 w-full transition-colors`,
      e.focused && !e.hasError && t`outline-default-low`,
      e.focused && e.hasError && t`outline-danger-low`,
      e.disabled ? t`bg-action-default-mid-disabled text-onaction-default-mid-disabled pointer-events-none` : t`bg-action-default-mid hover:bg-action-default-mid-hover`,
      !e.disabled && e.hasError && t`text-onaction-danger-mid`,
      !e.disabled && !e.hasError && t`text-onaction-default-mid`
    ]);
    return (o, E) => (n(), u(a(_), {
      class: m(i.value)
    }, {
      default: p(() => [
        s("div", y, [
          r(o.$slots, "value")
        ]),
        s("div", g, [
          h(a(x), { size: "20" })
        ]),
        o.required ? (n(), f("span", w, [
          r(o.$slots, "label"),
          v(B(o.required ? " *" : ""), 1)
        ])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  V as default
};
